export function bsCarouselNavDirective() {
    return {
        restrict: 'A',
        require: '^bsCarousel',
        link: function (scope, element, attrs, ctrl) {
            element.on('click', function () {
                ctrl.prevNextSlide(attrs['bsCarouselNav'] === 'right');
                scope.$digest();
            });
        }
    };
}
